var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstitutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10340_246768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22217 12.3704L15.9999 7.70374L23.7777 12.3704",
    stroke: "#1A1B1D",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 22.2222H6.66663",
    stroke: "#1A1B1D",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 12.3705H6.66663",
    stroke: "#1A1B1D",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.6666V20",
    stroke: "#1A1B1D",
    strokeWidth: 1.46667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 14.6666V20",
    stroke: "#1A1B1D",
    strokeWidth: 1.46667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 14.6666V20",
    stroke: "#1A1B1D",
    strokeWidth: 1.46667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 14.6666V20",
    stroke: "#1A1B1D",
    strokeWidth: 1.46667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10340_246768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 18.6667,
    fill: "white",
    transform: "translate(6.66663 6.66663)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionIcon);
export default __webpack_public_path__ + "static/media/institution-icon.1b4768d83adf9afd9f34320b7637eccd.svg";
export { ForwardRef as ReactComponent };